/**
 *
 * v.0.1  10/09/25  Inicial
 * v.0.2  18/09/25  Añadido efecto Zebra en rows.
 *                  Añadido evento estilizadorRow
 *                  Añadido resize de columnas:
 *                  Añadido autoResizeCol.
 *                  Añadida la opción de ordenación, con ordenado personalizado por tipo de columna
 * v.0.3  09/10/25  Corrección: reintroducidas las funciones auxiliares y columnas fijas
 * v.0.4  02/04/26  Añadido soporte para CELLTIPO_HTML (WYSIWYG)
 */

import React from 'react'
import PropTypes from 'prop-types';
import {
    CELLTIPO_CADENA,
    CELLTIPO_ELIMINARROW,
    CELLTIPO_ESTADOROW,
    CELLTIPO_FECHA,
    CELLTIPO_ICONOACCION,
    CELLTIPO_MEMO
} from "./TiposCeldas";
import {getValorCampo} from "../../../dental/utils/FormularioUtils";
import {Icon} from "@blueprintjs/core";
import DOMPurify from "dompurify";

// NUEVO TIPO
export const CELLTIPO_HTML = "html";

const filasZebraColoresDefecto= ["#f9f9f9", "#ffffff"];
const FLASH_BATCH_WINDOW = 150;
const FLASH_DURATION = 800;

class Tabla extends React.Component {
    constructor(props) {
        super(props)

        const columnas = props.columnas ? this.prepararColumnas(props) : [];

        this.state = {
            columnas,
            datos: props.datos ? props.datos : [],
            colWidths: columnas.map(c => c.ancho || 150),
            resizing: null,
            hoverCol: null,
            sortConfig: null,
            elementoSeleccionadoCodigo: null,

            celdasActualizadas: {},
            filasModificadas: new Set(),
            celdasTimestamp: {},
        }

        this.flashBuffer = new Set();
        this.flashFlushTimer = null;
        this.flashClearTimer = null;
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.datos !== this.props.datos &&
            this.props.datos !== this.state.datos
        ) {
            this.setState({ datos: this.props.datos });
        }
    }

    prepararColumnas = (props) => {
        let columnaE= { campo: "estadoRow", titulo:"E", minWidth: 10, ancho: 30, tipo: CELLTIPO_ESTADOROW, fija: true };
        let newColumnas = [columnaE, ...props.columnas];

        if (Boolean(props.mostrarEliminar)){
            let columnaEliminar= { campo: "eliminarRow", titulo: "X", minWidth: 10, ancho: 30, tipo: CELLTIPO_ELIMINARROW };
            newColumnas.push(columnaEliminar);
        }
        return newColumnas;
    }

    // ---------------- RESIZE ----------------
    handleMouseMoveTh = (e, index) => {
        if (this.state.resizing) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        if (rect.width - offsetX <= 5) {
            e.currentTarget.style.cursor = "col-resize";
            this.setState({ hoverCol: index });
        } else {
            e.currentTarget.style.cursor = "";
            this.setState({ hoverCol: null });
        }
    }

    handleMouseDownTh = (e, index) => {
        if (this.state.hoverCol === index) {
            this.setState({
                resizing: {
                    colIndex: index,
                    startX: e.clientX,
                    startWidth: this.state.colWidths[index]
                }
            });
            document.body.style.cursor = "col-resize";
            document.addEventListener("mousemove", this.onResize);
            document.addEventListener("mouseup", this.finalizarResize);
        }
    }

    onResize = (e) => {
        const { resizing, colWidths } = this.state;
        if (!resizing) return;
        const deltaX = e.clientX - resizing.startX;
        const newWidths = [...colWidths];
        newWidths[resizing.colIndex] = Math.max(50, resizing.startWidth + deltaX);
        this.setState({ colWidths: newWidths });
    }

    finalizarResize = () => {
        this.setState({ resizing: null });
        document.body.style.cursor = "";
        document.removeEventListener("mousemove", this.onResize);
        document.removeEventListener("mouseup", this.finalizarResize);
    }

    // ---------------- SORT ----------------
    handleSort = (columna) => {
        const { sortConfig, datos } = this.state;
        let direction = "asc";
        if (sortConfig?.campo === columna.campo && sortConfig.direction === "asc") {
            direction = "desc";
        }

        const sortedDatos = [...datos].sort((a, b) => {
            let A = getValorCampo(a, columna.campo, "");
            let B = getValorCampo(b, columna.campo, "");

            if (columna.tipo === CELLTIPO_FECHA) {
                return direction === "asc"
                    ? new Date(A) - new Date(B)
                    : new Date(B) - new Date(A);
            }

            A = String(A).toLowerCase();
            B = String(B).toLowerCase();

            if (A < B) return direction === "asc" ? -1 : 1;
            if (A > B) return direction === "asc" ? 1 : -1;
            return 0;
        });

        this.setState({ datos: sortedDatos, sortConfig: { campo: columna.campo, direction } });
    }

    // ---------------- UPDATE ----------------
    updateCell = (codigo, campo, valor) => {
        this.setState(prev => ({
            datos: prev.datos.map(r => r.codigo === codigo ? { ...r, [campo]: valor } : r),
            filasModificadas: new Set(prev.filasModificadas).add(codigo)
        }));
        this.enqueueFlash(codigo, campo);
    }

    enqueueFlash = (codigo, campo) => {
        const key = `${codigo}|${campo}`;
        this.flashBuffer.add(key);

        this.setState(prev => ({
            celdasTimestamp: { ...prev.celdasTimestamp, [key]: new Date() }
        }));

        if (!this.flashFlushTimer) {
            this.flashFlushTimer = setTimeout(() => this.flushFlashBuffer(), FLASH_BATCH_WINDOW);
        }
    }

    flushFlashBuffer = () => {
        const nuevas = {};
        this.flashBuffer.forEach(k => nuevas[k] = true);
        this.flashBuffer.clear();
        this.flashFlushTimer = null;

        this.setState(prev => ({
            celdasActualizadas: { ...prev.celdasActualizadas, ...nuevas }
        }));

        this.flashClearTimer = setTimeout(() => {
            this.setState({ celdasActualizadas: {} });
        }, FLASH_DURATION);
    }

    // ---------------- RENDER CELDAS ----------------
    renderHTML = (elemento, campo) => {
        const limpio = DOMPurify.sanitize(elemento[campo] || "");
        return <div dangerouslySetInnerHTML={{ __html: limpio }} />;
    }

    renderCelda = (columna, elemento) => {
        switch (columna.tipo) {
            case CELLTIPO_HTML: return this.renderHTML(elemento, columna.campo);
            case CELLTIPO_MEMO: return <div>{elemento[columna.campo]}</div>;
            case CELLTIPO_FECHA:
                return <div>{elemento[columna.campo] ? new Date(elemento[columna.campo]).toLocaleDateString("es-ES") : ""}</div>;
            case CELLTIPO_ICONOACCION:
                return <Icon icon={columna.icon} onClick={()=>columna.onAccion?.(elemento)} />;
            default:
                return <div>{getValorCampo(elemento, columna.campo, "")}</div>;
        }
    }

    render() {
        const { columnas, datos, colWidths } = this.state;

        return (
            <div style={{overflow:"auto", border:"1px solid #ccc"}}>
                <table style={{borderCollapse:"collapse", width:"100%", tableLayout:"fixed"}}>
                    <thead>
                    <tr>
                        {columnas.map((col, i) => (
                            <th key={i}
                                style={{border:"1px solid #ccc", padding:"8px", width:colWidths[i]}}
                                onMouseMove={(e)=>this.handleMouseMoveTh(e,i)}
                                onMouseDown={(e)=>this.handleMouseDownTh(e,i)}
                                onClick={()=>this.handleSort(col)}
                            >
                                {col.titulo}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {datos.map((row, r) => (
                        <tr key={row.codigo}>
                            {columnas.map((col, c) => {
                                const key = `${row.codigo}|${col.campo}`;
                                const flash = this.state.celdasActualizadas[key];

                                return (
                                    <td key={c}
                                        style={{
                                            border:"1px solid #ccc",
                                            padding:"8px",
                                            backgroundColor: flash ? "#d4edda" : undefined,
                                            whiteSpace: col.tipo===CELLTIPO_HTML || col.tipo===CELLTIPO_MEMO ? "pre-wrap" : "nowrap"
                                        }}>
                                        {this.renderCelda(col, row)}
                                    </td>
                                )
                            })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

Tabla.propTypes = {
    datos: PropTypes.array,
    columnas: PropTypes.array,
    mostrarEliminar: PropTypes.bool,
    onEliminar: PropTypes.func,
}

export default Tabla;